// extracted by mini-css-extract-plugin
export default {"container":"PersonalData_container__90ut5","row":"PersonalData_row__9ZRL3","name":"PersonalData_name__Ekl7b","personalDataSelect":"PersonalData_personalDataSelect__3uSPg"};